module.exports = __webpack_public_path__ + "static/media/iconmonstr-linkedin-5.289741cf.svg";